angular.module('pitch.app')

.factory('TerritoryControl', function(config, $resource) {
    return $resource(config.apiUri + '/songs/:tempoSongId/control');
});



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/services/TerritoryControl.js